module.exports = __webpack_public_path__ + "img/419b3f11c0ec1f955bae043fe445132c.9d38af2a.png";